import { Controller } from "stimulus"
import axios from 'axios';
export default class extends Controller {
  static get targets() {
    return ['contentModal', 'form'];
  }
 
  
  initialize(){

  }
  






  onSubmitFail(e){
    this.renderForm(e.detail[2].response);
    
  }

  renderForm(response){
    
    this.element.innerHTML = response;


  }

  submitSuccessModal(e){
   let modal =  this.contentModalTarget    
   modal.querySelector('.modal-body').innerHTML = e.detail[2].response; 
   $(modal).modal('show');
  }

}
